module.exports = __webpack_public_path__ + "static/media/get-it-on-stores.09ef65fe.svg";